import ActionNode from './ActionNode';
import ConditionNode from './ConditionNode';
import DelayNode from './DelayNode';
import StartNode from './StartNode';
import EndNode from './EndNode';
import ApiNode from './ApiNode';
import { ABTestNode } from './ABTestNode';
import { UpdateProfileNode } from './UpdateProfileNode';
import { MessageReadNode } from './MessageReadNode';
import DynamicDelayNode from './DynamicDelayNode';
import ButtonClickedNode from './ButtonClickedNode';
import EnhancedConditionNode from './EnhancedConditionNode';
import DTMFNode from './DTMFNode';
import IVRNode from './IVRNode';
import CustomerProfileNode from './CustomerProfileNode';
import SmsInboundNode from './SmsInboundNode';
import SmartConditionNode from './SmartConditionNode';
import CallFlowNode from './CallFlowNode';
import CallWhatsappFlowNode from './CallWhatsappFlowNode';
import MultiStepNode from './MultiStepNode';
import MergeNode from './MergeNode';
import CheckChannelConsentNode from './CheckChannelConsentNode';
import UpdateChannelConsentNode from './UpdateChannelConsentNode';

export const nodeTypes = {
    actionNode: ActionNode,
    conditionNode: ConditionNode,
    delayNode: DelayNode,
    startNode: StartNode,
    endNode: EndNode,
    apiNode: ApiNode,
    abTestNode: ABTestNode,
    updateProfileNode: UpdateProfileNode,
    messageReadNode: MessageReadNode,
    dynamicDelayNode: DynamicDelayNode,
    buttonClickedNode: ButtonClickedNode,
    enhancedConditionNode: EnhancedConditionNode,
    dtmfNode: DTMFNode,
    ivrNode: IVRNode,
    customerProfileNode: CustomerProfileNode,
    smsInboundNode: SmsInboundNode,
    smartConditionNode: SmartConditionNode,
    callFlowNode: CallFlowNode,
    callWhatsappFlowNode: CallWhatsappFlowNode,
    multiStepNode: MultiStepNode,
    mergeNode: MergeNode,
    checkChannelConsentNode: CheckChannelConsentNode,
    updateChannelConsentNode: UpdateChannelConsentNode,
};

export { ActionNode, ConditionNode, DelayNode, StartNode, EndNode, ApiNode, ABTestNode, UpdateProfileNode, MessageReadNode };